import KeenSlider from 'keen-slider'

window.addEventListener('DOMContentLoaded', () => {
	// This is specifically for videos with chapters (harm reduction page)
	const videoSections = document.querySelectorAll('.video.has-chapters')

	videoSections.forEach(videoSection => {
		let vidWrapper = videoSection.querySelector('.playVid')
		let plyBtn = videoSection.querySelector('.video-play')
		let chapters = videoSection.querySelectorAll('.chapters .chapter')
		let video = videoSection.querySelector('video')

		function videoPausePlayHandler(e) {
			if (e.type == 'playing') {
				plyBtn.style.display = 'none'
				vidWrapper.classList.remove('paused')
			} else if (e.type == 'pause') {
				if (!video.seeking) {
					video.removeAttribute('controls')
					plyBtn.style.display = 'block'
					vidWrapper.classList.add('paused')
				}
			}
		}

		if (vidWrapper && video) {
			vidWrapper.addEventListener('click', () => {
				video.play()
			})

			video.addEventListener('playing', videoPausePlayHandler, false)
			video.addEventListener('pause', videoPausePlayHandler, false)
		}

		chapters.forEach(chapter => {
			chapter.addEventListener('click', () => {
				let time = chapter.dataset.timestamp.split(':')
				let mins = parseInt(time[0])
				let secs = parseInt(time[1])
				video.currentTime = mins * 60 + secs
				video.play()
			})
		})

		let chaptersWrapper = videoSection.querySelector('.chapters')
		let chaptersSlider = videoSection.querySelector('.keen-slider')
		var slider = new KeenSlider(
			chaptersSlider,
			{
				slides: {
					perView: 2,
					spacing: 8,
				},
				breakpoints: {
					'(min-width: 500px)': {
						slides: {
							perView: 3,
							spacing: 8,
						},
					},
					'(min-width: 767px)': {
						slides: {
							perView: 4,
							spacing: 8,
						},
					},
					'(min-width: 1500px)': {
						slides: {
							perView: 5,
							spacing: 8,
						},
					},
					'(min-width: 1900px)': {
						slides: {
							perView: 6,
							spacing: 8,
						},
					},
				},
			},
			[
				slider => {
					let prevBtn = chaptersWrapper.querySelector('button.prev')
					let nextBtn = chaptersWrapper.querySelector('button.next')

					prevBtn?.addEventListener('click', () => {
						slider.prev()
					})

					nextBtn?.addEventListener('click', () => {
						slider.next()
					})
				},
			]
		)
	})
})
